import { DiscountCodeApi } from 'common/types';
import { newFirestoreId } from 'common/utils/newRentalUtils';
import errorHandler from 'common/services/errorHandler';
import { api } from 'common/frontend/api';

type CreateDiscountCodeArgs = Omit<DiscountCodeApi, 'id'>;

export const isUniqueShopDiscountCode = async (discountCode: string, shopId: string) => {
	try {
		const existingCodes = await api()
			.discountCodes.get.whereArray('shopIds', 'array-contains', shopId)
			.where('code', '==', discountCode)
			.get();
		if (!!existingCodes.length) {
			return false;
		}
		return true;
	} catch (e) {
		errorHandler.report(e);
		throw e;
	}
};

export const createDiscountCode = async (args: CreateDiscountCodeArgs) => {
	try {
		const discountCodeId = newFirestoreId();
		const discountCode: DiscountCodeApi = {
			id: discountCodeId,
			code: args.code,
			shopIds: args.shopIds,
			priceRule: args.priceRule,
			usageCount: args.usageCount,
			...(args.usageLimit !== undefined && { usageLimit: args.usageLimit }),
			entitledCategoryIds: args.entitledCategoryIds,
			entitledProductIds: args.entitledProductIds,
			validFrom: args.validFrom,
			validTo: args.validTo,
			bookingStartDateFrom: args.bookingStartDateFrom,
			bookingStartDateTo: args.bookingStartDateTo,
		};
		await api().discountCodes.doc(discountCodeId).set(discountCode);
	} catch (e) {
		throw new Error(e);
	}
};
